<div class="home-container">
  <!-- Welcome Header -->
  <div class="home-header">
    <div class="header-content">
      <div class="greeting">
        <h1>Welcome, {{ userName }}</h1>
        <p class="subtitle">What would you like to do today?</p>
      </div>
      <div class="header-date">
        {{ today | date:'EEEE, MMMM d, yyyy' }}
      </div>
    </div>
  </div>

  <!-- Quick Actions Grid -->
  <div class="section-title">Quick Actions</div>
  <div class="actions-grid">
    <div class="action-card" *ngFor="let action of visibleQuickActions" (click)="navigateTo(action.route)">
      <div class="action-icon">
        <mat-icon>{{ action.icon }}</mat-icon>
      </div>
      <div class="action-info">
        <h3>{{ action.title }}</h3>
        <p>{{ action.description }}</p>
      </div>
      <mat-icon class="action-arrow">chevron_right</mat-icon>
    </div>
  </div>

  <ng-container>
    <div class="section-header">
      <div class="section-title">Home Page Summary
        <span class="rework-count">{{ summaryTotal }}</span>
      </div>
      <div class="section-actions">
        <mat-form-field appearance="outline" class="summary-search-field">
          <mat-label>Quick Search</mat-label>
          <input
            matInput
            [(ngModel)]="summarySearchTerm"
            (ngModelChange)="onSummarySearchTermChange($event)"
            placeholder="Doctor, patient, job id, status...">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <button mat-stroked-button color="primary" (click)="exportHomeSummary()" [disabled]="summaryExporting">
          <mat-icon>download</mat-icon> Export Summary
        </button>
        <button mat-stroked-button color="primary" (click)="refreshHomeSummary()" [disabled]="summaryLoading">
          <mat-icon>refresh</mat-icon> Refresh
        </button>
      </div>
    </div>
    <div class="section-subtitle">
      Draft and in-production jobs visible to the logged-in sales or communication user.
    </div>

    <div class="rework-table-wrapper">
      <table
        mat-table
        [dataSource]="summaryRows"
        class="mat-elevation-z1 rework-table summary-table"
        matSort
        matSortDisableClear
        [matSortActive]="summarySortField"
        [matSortDirection]="summarySortDirection"
        (matSortChange)="onSummarySortChange($event)">
        <ng-container matColumnDef="sr_no">
          <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
          <td mat-cell *matCellDef="let row; let i = index">{{ summarySerialNumber(i) }}</td>
        </ng-container>
        <ng-container matColumnDef="doctor_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="doctor_name">Doctor Name</th>
          <td mat-cell *matCellDef="let row">{{ row.doctor_name }}</td>
        </ng-container>
        <ng-container matColumnDef="patient_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="patient_name">Patient Name</th>
          <td mat-cell *matCellDef="let row">{{ row.patient_name }}</td>
        </ng-container>
        <ng-container matColumnDef="job_no">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="job_no">Job Id</th>
          <td mat-cell *matCellDef="let row">{{ row.job_no }}</td>
        </ng-container>
        <ng-container matColumnDef="product_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="product_name">Product</th>
          <td mat-cell *matCellDef="let row">{{ row.product_name }}</td>
        </ng-container>
        <ng-container matColumnDef="job_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="job_date">Job In Date</th>
          <td mat-cell *matCellDef="let row">{{ row.job_date }}</td>
        </ng-container>
        <ng-container matColumnDef="delivery_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="delivery_date">Delivery Date</th>
          <td mat-cell *matCellDef="let row">{{ row.delivery_date }}</td>
        </ng-container>
        <ng-container matColumnDef="job_status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="job_status">Job Status</th>
          <td mat-cell *matCellDef="let row">{{ row.job_status }}</td>
        </ng-container>
        <ng-container matColumnDef="current_status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="current_status">Current Status</th>
          <td mat-cell *matCellDef="let row">{{ row.current_status }}</td>
        </ng-container>
        <ng-container matColumnDef="type_label">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="type_label">Type</th>
          <td mat-cell *matCellDef="let row">{{ row.type_label }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="summaryColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: summaryColumns" class="rework-row" (click)="openSummaryJob(row)"></tr>
      </table>

      <div class="rework-empty" *ngIf="!summaryLoading && summaryRows.length === 0">
        No draft or in-production jobs found for this user.
      </div>

      <mat-paginator
        #summaryPaginator
        [length]="summaryTotal"
        [pageSize]="summaryPageSize"
        [pageIndex]="summaryPageIndex"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="onSummaryPage($event)"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </ng-container>

  <!-- Rework Queue (Admin role sees all; other roles see jobs scoped by their linked employee access) -->
  <ng-container>
    <div class="section-header">
      <div class="section-title">Jobs in Rework
        <span class="rework-count">{{ reworkTotal }}</span>
      </div>
      <div class="section-actions">
        <button mat-stroked-button color="primary" (click)="refreshReworkQueue()" [disabled]="reworkLoading">
          <mat-icon>refresh</mat-icon> Refresh
        </button>
      </div>
    </div>

    <div class="rework-table-wrapper">
      <table mat-table [dataSource]="reworkRows" class="mat-elevation-z1 rework-table">
        <ng-container matColumnDef="job_no">
          <th mat-header-cell *matHeaderCellDef>Job No</th>
          <td mat-cell *matCellDef="let r">{{ r.job_no }}<div class="muted">{{ r.patient_name }}</div></td>
        </ng-container>
        <ng-container matColumnDef="doctor_name">
          <th mat-header-cell *matHeaderCellDef>Doctor</th>
          <td mat-cell *matCellDef="let r">{{ r.doctor_name }}</td>
        </ng-container>
        <ng-container matColumnDef="product_name">
          <th mat-header-cell *matHeaderCellDef>Product</th>
          <td mat-cell *matCellDef="let r">{{ r.product_name }}</td>
        </ng-container>
        <ng-container matColumnDef="rework_process">
          <th mat-header-cell *matHeaderCellDef>Rework Process</th>
          <td mat-cell *matCellDef="let r">
            {{ r.rework_process }}
            <div class="muted" *ngIf="r.from_process">from {{ r.from_process }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="department_name">
          <th mat-header-cell *matHeaderCellDef>Department</th>
          <td mat-cell *matCellDef="let r">
            {{ r.department_name }}
            <div class="muted" *ngIf="r.employee_name">by {{ r.employee_name }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="rework_reason">
          <th mat-header-cell *matHeaderCellDef>Rework Reason</th>
          <td mat-cell *matCellDef="let r" class="reason-cell">{{ r.rework_reason }}</td>
        </ng-container>
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Sent On</th>
          <td mat-cell *matCellDef="let r">{{ r.created_at }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="reworkColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: reworkColumns" class="rework-row" (click)="openReworkJob(row)"></tr>
      </table>

      <div class="rework-empty" *ngIf="!reworkLoading && reworkRows.length === 0">
        No jobs are currently in rework.
      </div>

      <mat-paginator
        #reworkPaginator
        [length]="reworkTotal"
        [pageSize]="reworkPageSize"
        [pageIndex]="reworkPageIndex"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="onReworkPage($event)"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </ng-container>
</div>
